import React from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useMatch } from "react-router-dom";

import { useGroupLookup } from "@/api/groups";
import { Avatar, Button, HStack } from "@/components/ui";
import { useComposer } from "@/contexts/composer-context";
import { useModalContext } from "@/contexts/modal-context";

const ComposeButton = () => {
  const location = useLocation();
  const isOnGroupPage = location.pathname.startsWith("/group/");
  const match = useMatch("/group/:groupSlug");
  const { group } = useGroupLookup(match?.params.groupSlug || "");
  const isGroupMember = !!group?.relationship?.member;

  if (isOnGroupPage && isGroupMember) {
    return <GroupComposeButton />;
  }

  return <HomeComposeButton />;
};

const HomeComposeButton = () => {
  const { openModal } = useModalContext();

  const onOpenCompose = () => {
    openModal("COMPOSE");
  };

  return (
    <Button variant="accent" size="lg" onClick={onOpenCompose} block>
      <FormattedMessage id="navigation.compose" defaultMessage="Compose" />
    </Button>
  );
};

const GroupComposeButton = () => {
  const match = useMatch("/group/:groupSlug");
  const { group } = useGroupLookup(match?.params.groupSlug || "");
  const { openModal } = useModalContext();

  const composeId = `group:${group?.id}`;
  const { updateComposer } = useComposer(composeId);

  if (!group) return null;

  const onOpenCompose = () => {
    updateComposer({ groupId: group.id });

    openModal("COMPOSE", {
      composeId,
      audienceReadable: true,
      groupId: group.id,
    });
  };

  return (
    <Button variant="accent" size="lg" onClick={onOpenCompose} block>
      <HStack space={3} alignItems="center">
        <Avatar
          className="-my-1 border-2 border-white"
          size={30}
          src={group.avatar_static}
        />
        <span>
          <FormattedMessage
            id="navigation.compose_group"
            defaultMessage="Compose to Group"
          />
        </span>
      </HStack>
    </Button>
  );
};

export default ComposeButton;
